import qs from "qs";
import http from "../http";

function getTaskDetail(payload) {
  return http("GET", `${window.API_URL}/task/${payload.id}`);
}

function getTasks(payload) {
  const queryString = qs.stringify(payload);
  return http("GET", `${window.API_URL}/tasks?${queryString}`);
}

function getTasksEdit(payload) {
  return http("GET", `${window.API_URL}/tasks/${payload.id}/edit`);
}

function getTasksMembers(payload) {
  return http("GET", `${window.API_URL}/tasks/${payload.id}/members`);
}

function getTasksTimes(payload) {
  return http("GET", `${window.API_URL}/tasks/${payload.id}/times`);
}

function getProjectsName(payload) {
  return http("GET", `${window.API_URL}/projects/${payload.id}/name`);
}

function deleteTasks(payload) {
  return http("DELETE", `${window.API_URL}/tasks/${payload.id}`);
}

function createTask(payload) {
  return http("POST", `${window.API_URL}/task`, payload);
}

function updateTask(payload) {
  return http("PUT", `${window.API_URL}/task`, payload);
}

function getTaskInterfaces() {
  return http("GET", `${window.API_URL}/taskInterface`);
}

function createProejctResult(payload) {
  return http(
    "POST",
    `${window.API_URL}/project/${payload.id}/result`,
    payload.options
  );
}

function createTaskResult(payload) {
  return http(
    "POST",
    `${window.API_URL}/task/${payload.id}/result`,
    payload.options
  );
}

function getTaskRoles(payload) {
  return http("GET", `${window.API_URL}/tasks/${payload.taskId}/member/roles`);
}

function getTaskProjects() {
  return http("GET", `${window.API_URL}/taskProject`);
}

function getCandidates(payload) {
  return http(
    "GET",
    `${window.API_URL}/task/set/candidates?${qs.stringify(payload)}`
  );
}

function updateCandidates(payload) {
  return http(
    "PUT",
    `${window.API_URL}/task/set/candidates`,
    payload,
    { interceptor: false },
    {
      "Content-Type": "multipart/form-data",
    }
  );
}

function setCandidates(payload) {
  return http("POST", `${window.API_URL}/task/set/candidates`, payload);
}

function downloadCandidatesCSV(payload) {
  return http(
    "GET",
    `${window.API_URL}/task/set/candidates/csv?${qs.stringify(payload)}`
  );
}

function getCandidatesCount(payload) {
  return http(
    "GET",
    `${window.API_URL}/task/set/candidates/count?${qs.stringify(payload)}`
  );
}

function resetCandidates(payload) {
  return http("POST", `${window.API_URL}/task/set/candidates/re`, payload);
}

function deleteCandidates(payload) {
  return http("DELETE", `${window.API_URL}/task/set/candidates`, payload);
}

export default {
  getTaskDetail,
  getTasks,
  getTasksEdit,
  getTasksMembers,
  getTasksTimes,
  getProjectsName,
  deleteTasks,
  createTask,
  updateTask,
  getTaskProjects,
  getTaskInterfaces,
  createProejctResult,
  createTaskResult,
  getTaskRoles,
  getCandidates,
  updateCandidates,
  setCandidates,
  downloadCandidatesCSV,
  getCandidatesCount,
  resetCandidates,
  deleteCandidates,
};
